import React from 'react';

import { noop } from '@/utility/noop';

const falsefn = (): boolean => false;

export const createChangeEvent = <ElementType extends HTMLInputElement>(
  input: ElementType | null,
  value: string,
): React.ChangeEvent<ElementType> | null => {
  if (!input) {
    throw new Error('cannot process card radio button due to missing input');
  }
  input.value = value;

  const event = new Event('change', { bubbles: true });

  return {
    nativeEvent: event,
    target: input,
    currentTarget: input,
    bubbles: event.bubbles,
    cancelable: event.cancelable,
    defaultPrevented: event.defaultPrevented,
    eventPhase: event.eventPhase,
    isTrusted: event.isTrusted,
    timeStamp: event.timeStamp,
    type: event.type,
    preventDefault: noop,
    stopPropagation: noop,
    isPropagationStopped: falsefn,
    isDefaultPrevented: falsefn,
    persist: noop,
  };
};
